import script from "./icon-two-tones-graph.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-two-tones-graph.vue?vue&type=script&lang=ts&setup=true"

import "./icon-two-tones-graph.vue?vue&type=style&index=0&id=3c0f3fb4&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c0f3fb4"]])

export default __exports__